module.exports = __webpack_public_path__ + "media/images/btn_statistics-65df54983a33b830391f1963c2a6bcbb.gif";